<template>
  <el-select
    style="width: auto"
    v-model="currentValue"
    placeholder="请输入成员名称，可搜索"
    filterable
    value-key="userId"
    multiple
    collapse-tags
    remote
    :remote-method="remoteMethodUser"
    @change="handleChange"
    @input="handleChange"
    :multiple-limit="multipleLimit"
    @remove-tag="handleRemove"
  >
    <el-option
      v-for="item in userOptions"
      :key="item.userId"
      :label="item.userName"
      :value="item"
      :disabled="isDisabled(item)"
    >
      <el-row>
        <el-col :span="24">
          {{ item.userName }} {{ item.userId }}
          <span v-if="isInDisabledOptions(item)">
            ({{ disabledOptionsRemark }})
          </span>
          <span v-else-if="isDisabledNullBeisen(item)">(北森ID为空)</span>
          <span v-else-if="isUnEffective(item)">(离职或禁用)</span>
        </el-col>
      </el-row>
    </el-option>
  </el-select>
</template>

<script>
import { getAllUserOptions } from "@/components/workOrderUserSelectV2/userOptionsService.js";

export default {
  name: "workOrderUserSelect",
  props: {
    value: {
      required: true,
      type: Array,
      default: () => [],
    },
    multipleLimit: {
      type: Number,
      default: 0,
    },
    disabledOptions: {
      type: Array,
      default: () => [],
    },
    disabledOptionsRemark: {
      type: String,
      default: "禁选",
    },
    disabledUnEffective: {
      type: Boolean,
      default: true,
    },
    disabledNullBeisen: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    value: {
      handler: function (val) {
        this.initUserOptions();
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      allOptions: [],
      userOptions: [],
    };
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value;
      },
      set: function () {},
    },
  },
  created() {
    this.getAllUserList();
  },
  activated() {
    this.getAllUserList();
  },
  methods: {
    async getAllUserList() {
      this.allOptions = await getAllUserOptions();
      this.initUserOptions();
    },
    initUserOptions() {
      const selectedIds = this.value.map((item) => item.userId);
      const selectedItems = this.allOptions.filter((item) =>
        selectedIds.includes(item.userId)
      );
      const filters = this.allOptions
        .filter((item) => !selectedIds.includes(item.userId))
        .slice(0, 10);
      this.userOptions = [...selectedItems, ...filters];
    },
    remoteMethodUser(query) {
      const selectedIds = this.value.map((item) => item.userId);
      if (query) {
        const selectedItems = this.allOptions.filter((item) =>
          selectedIds.includes(item.userId)
        );
        let filters = this.allOptions
          .filter(
            (item) =>
              item.userName.includes(query) &&
              !selectedIds.includes(item.userId)
          )
          .slice(0, 10);
        this.userOptions = [...selectedItems, ...filters];
      }
    },
    handleChange(value) {
      this.$emit("input", value);
    },
    handleRemove(e) {
      if (this.disabledOptions.includes(e.userId)) {
        this.$emit("input", this.currentValue);
        return this.$message.error("该成员不允许删除");
      }
    },
    // 选项禁用
    isInDisabledOptions(item) {
      if (this.disabledOptions.includes(item.userId)) {
        return true;
      }
      return false;
    },
    isUnEffective(item) {
      if (this.disabledUnEffective) {
        if (item.effective != undefined && item.effective === false) {
          return true;
        }
      }
      return false;
    },
    isDisabledNullBeisen(item) {
      if (this.disabledNullBeisen) {
        if (
          item.beisenUserId === undefined ||
          item.beisenUserId === null ||
          item.beisenUserId == 0
        ) {
          return true;
        }
      }
      return false;
    },
    isDisabled(item) {
      if (this.isInDisabledOptions(item)) {
        return true;
      }
      if (this.isDisabledNullBeisen(item)) {
        return true;
      }
      if (this.isUnEffective(item)) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
